import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LastViewProduct, Product } from 'src/app/interfaces/api/product';
import { Preferences } from '@capacitor/preferences';
import { City } from 'src/app/interfaces/api/city';
import { CartService } from 'src/app/services/cart.service';
import { ModalController, ToastController } from '@ionic/angular';
import { ProductService } from 'src/app/services/product.service';
import { ModalSelectCityBranchComponent } from '../modal-select-city-branch/modal-select-city-branch.component';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { encodeQueryParam, transformWeight } from 'src/helpers';

@Component({
  selector: 'app-home-product',
  templateUrl: './home-product.component.html',
  styleUrls: ['./home-product.component.scss'],
})
export class HomeProductComponent implements OnInit {
  @Input() product: Product;
  @Input() isLoading: boolean;
  @Input() showButtons = true;
  @Output() completeAddToCart = new EventEmitter();
  isNewProduct: boolean;
  selectedCity: City;
  isWishlisted: boolean;
  last_viewed_product: LastViewProduct;
  recently_viewed: boolean;
  weight: string;

  constructor(
    private toastController: ToastController,
    private cartService: CartService,
    private productService: ProductService,
    private modalController: ModalController,
    private router: Router,
  ) {}

  async ngOnInit() {
    this.selectedCity = JSON.parse((await Preferences.get({ key: 'selectedCity' })).value);
    this.last_viewed_product = JSON.parse((await Preferences.get({ key: 'last_viewed_product' })).value);
    this.weight = transformWeight(this.product?.weight);

    if (!this.last_viewed_product || !this.product) {
      this.recently_viewed = false;
      return;
    }

    this.isWishlisted = this.product?.is_wishlisted;

    // product is viewed in last 30 minutes
    const isRecent = new Date().getTime() - this.last_viewed_product.last_view < 30 * 60 * 1000;
    const isSameProduct = this.last_viewed_product.product_id === this.product.id;
    this.recently_viewed = isRecent && isSameProduct;
  }

  toNumber(str: string) {
    return parseFloat(str);
  }

  onAddToCart(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.product.stock === 0) {
      this.presentToast('Stok kurang silahkan pilih barang lain');
      return false;
    }

    const cartReq = this.cartService.addToCart(this.product.id, 1, this.product.id_mh_warehouse);
    const cartCountReq = this.cartService.getCartCount();

    forkJoin([cartReq, cartCountReq]).subscribe({
      next: ([cartRes, cartCountRes]) => {
        this.presentToast(cartRes.message);
        console.log(cartRes, cartCountRes);
        this.cartService.setCartCount(cartCountRes.count);
      },
      complete: () => {
        this.completeAddToCart.emit();
      },
    });
  }

  async addWishlist(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    const selectedCity = JSON.parse((await Preferences.get({ key: 'selectedCity' })).value);

    if (!selectedCity || !selectedCity.id) {
      this.presentToast('Kamu belum memilih kota pembelian');
      return;
    }

    if (this.isWishlisted) {
      this.presentToast(`Produk sudah ada dalam wishlist mu!`);
      return;
    }

    const payload = {
      id_mh_product: Number(this.product.id),
      id_mh_city: selectedCity.id,
    };

    this.productService.storeWishlist(payload).subscribe({
      next: async val => {
        if (val) {
          this.isWishlisted = true;
          this.presentToast(val.message);
        }
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  goToProductDetailPage() {
    this.router.navigate(['product-detail', this.product.id], {
      queryParams: {
        selectedWarehouseId: encodeQueryParam(this.product.id_mh_warehouse),
      },
    });
  }

  protected async presentToast(message: string, duration: number = 1000): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration,
      mode: 'ios',
    });
    return await toast.present();
  }
}
